import { articleListedState as state } from './articleListedState';
import { articleListedNavBar as navBar } from './articleListedNavBar';
import { articleListedSwiper as swiper } from './articleListedSwiper';
import {
  articleListedToggleChapter as toggleChapter,
  activeChapterToInfoBox,
} from './articleListedToggleChapter';
import { chapters } from './articleListedElements';
import { addButtonChapterParam } from './articleListedChapterRegParamUpdate';

const ArticleListed = (): void => {
  // Init ve 'window'
  window.__cncPageDefinition = window.__cncPageDefinition || {};
  window.__cncPageDefinition.isListArticle = true;

  // Nastavit poslední kapitolu
  state.setLastChapter(chapters.length);

  // Zobrazit první část článku
  toggleChapter();

  // Navigace
  navBar();

  // Swiper
  swiper();

  activeChapterToInfoBox();

  addButtonChapterParam();
};

export default ArticleListed;
